import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from './error.service';
import { INews } from '../interfaces/INews';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class NewsService {
    private readonly httpClient = inject(HttpClient);
    private readonly errorService = inject(ErrorService);
    private readonly apiUrl = environment.endpoint;

    public getNewsData(): Observable<INews[]> {
        const url = `${this.apiUrl}/news`;

        return this.httpClient.get<INews[]>(url).pipe(
            map(data => data ?? []),
            catchError(this.errorService.handleError<INews[]>('get news'))
        );
    }
}
